import { Box, IconButton } from "@material-ui/core";
import React from "react";
import EditIcon from '@material-ui/icons/Edit';
import { SpecCreator } from "./SpecCreator";
import { useDialogProps } from "legacy-components/dialog/Dialog";
import DataRemover from "modus/components/misc/DataRemover";
import DeleteIcon from "legacy-components/icons/DeleteIcon";
import { Alert } from "@material-ui/lab";
import { useAsyncAction } from "legacy-components/form/action/AsyncAction";
import ApiService from "../services/ApiService";
import {ResourceAuthorizer} from "../../authorizer/components/Authorizer";

interface SpecEditorProps {
  apiId: string;
  version: string;
  specId: string;
  specFile: string;
  refreshDeployments: ()=>void;
  serviceId: string;
}

export const SpecEditor: React.FC<SpecEditorProps> = React.memo(({ apiId, version, specId, specFile, refreshDeployments, serviceId }) => {
    const { open, toggle } = useDialogProps();

     const [state, { subscribe }] = useAsyncAction(() =>
     ApiService.deleteSpec(apiId, version, specId)
  );

  return (
    <>
        <ResourceAuthorizer action={"update"} resourceType={"SERVICE"} resourceId={serviceId} hideErrorMessage>
        <IconButton onClick={toggle} >
        <EditIcon  />
      </IconButton>
        </ResourceAuthorizer>

        <ResourceAuthorizer action={"delete"} resourceType={"SERVICE"} resourceId={serviceId} hideErrorMessage>
        <DataRemover
        style={{
          border: "none",
        }}
        confirmationText={""}
        enterButtonText={undefined}
        onConfirm={subscribe}
        asyncActionState={state}
        tooltipText={"This will delete the spec permanently."}
        title="Delete openapi spec"
        successMessage="Deleted spec"
        onSuccess={refreshDeployments}
        icon={<DeleteIcon style={{ color: "#900b09", border: "none" }}></DeleteIcon>}
        disabled={specId === undefined || specId.length === 0}
        message={
          <Box>
            <Alert severity="error">
              Deleting a spec will break any current integrations
              using this version.
            </Alert>
            <Box marginTop={"30px"}>
              This action cannot be undone. This will permanently remove
              the open Api specification cannot be accessed elsewhere.
              <br />
            </Box>
          </Box>
        }
      />
        </ResourceAuthorizer>

        <ResourceAuthorizer action={"update"} resourceType={"SERVICE"} resourceId={serviceId} hideErrorMessage>
        <SpecCreator
          apiId={apiId}
          version={version}
          onClose={toggle}
          onOpen={open}
          refreshDeployments={refreshDeployments}
        />
        </ResourceAuthorizer>
    </>
  )
})